import { render } from "./LoginForm.component.vue?vue&type=template&id=29ce99a2"
import script from "./LoginForm.component.vue?vue&type=script&lang=js"
export * from "./LoginForm.component.vue?vue&type=script&lang=js"

import "./LoginForm.component.vue?vue&type=style&index=0&id=29ce99a2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QIcon,QBtn});
